export interface Category {
  name: string;
  nameRu: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    nameRu: 'Обувь',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20white%20sneakers%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20window%20lighting%20editorial%20style%20single%20pair%20of%20stylish%20sneakers%20warm%20beige%20aesthetic%20simple%20background%20no%20text%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-01&orientation=landscape'
  },
  {
    name: 'Hoodies/Sweaters',
    nameRu: 'Худи и Свитеры',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20neutral%20beige%20hoodie%20flat%20lay%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20folded%20cozy%20sweatshirt%20minimalist%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-02&orientation=landscape'
  },
  {
    name: 'T-Shirts',
    nameRu: 'Футболки',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20cotton%20white%20t-shirt%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20neatly%20folded%20tee%20minimalist%20aesthetic%20simple%20background%20no%20text%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-03&orientation=landscape'
  },
  {
    name: 'Jackets',
    nameRu: 'Куртки',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20olive%20green%20jacket%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20window%20lighting%20editorial%20style%20lightweight%20outerwear%20clean%20composition%20minimalist%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-04&orientation=landscape'
  },
  {
    name: 'Pants/Shorts',
    nameRu: 'Штаны и Шорты',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Casual%20beige%20trousers%20flat%20lay%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20neatly%20folded%20pants%20minimalist%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-05&orientation=landscape'
  },
  {
    name: 'Headwear',
    nameRu: 'Головные уборы',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20neutral%20baseball%20cap%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20hat%20minimalist%20composition%20simple%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-06&orientation=landscape'
  },
  {
    name: 'Sets',
    nameRu: 'Комплекты',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20outfit%20clothing%20set%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20coordinated%20top%20and%20bottom%20neatly%20arranged%20minimalist%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-07&orientation=landscape'
  },
  {
    name: 'Underwear/Underpants',
    nameRu: 'Нижнее бельё',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20cotton%20underwear%20basics%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20neatly%20folded%20undergarments%20minimalist%20aesthetic%20simple%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-08&orientation=landscape'
  },
  {
    name: 'Jersey',
    nameRu: 'Джерси',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sports%20athletic%20jersey%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20performance%20fabric%20top%20neatly%20folded%20minimalist%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-09&orientation=landscape'
  },
  {
    name: 'Accessories',
    nameRu: 'Аксессуары',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20accessories%20product%20photography%20sunglasses%20and%20minimalist%20watch%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20elegant%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-10&orientation=landscape'
  },
  {
    name: 'Bags',
    nameRu: 'Сумки',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20leather%20tote%20bag%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20window%20lighting%20editorial%20style%20clean%20composition%20simple%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-11&orientation=landscape'
  },
  {
    name: 'Belts',
    nameRu: 'Ремни',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genuine%20leather%20belt%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20rolled%20belt%20with%20subtle%20buckle%20minimalist%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-12&orientation=landscape'
  },
  {
    name: 'Perfumes',
    nameRu: 'Парфюмерия',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20amber%20fragrance%20minimalist%20composition%20clean%20aesthetic%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-13&orientation=landscape'
  },
  {
    name: 'Other Stuff',
    nameRu: 'Прочее',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Miscellaneous%20fashion%20lifestyle%20items%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20various%20small%20accessories%20neatly%20arranged%20minimalist%20composition%20clean%20background%20no%20people&width=400&height=300&seq=yoybuy-cat-v2-14&orientation=landscape'
  },
];